import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MDBBootstrapModule } from 'angular-bootstrap-md';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';

import { RouterModule } from '@angular/router';
import { ContactComponent } from './pages/contact/contact.component';

import { AdventureComponent } from './pages/adventure/adventure.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HttpClientModule } from '@angular/common/http';

import { AngularFireModule } from '@angular/fire';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { from } from 'rxjs';
import { FirebaseService } from './service/firebase.service';
import { SignComponent } from './pages/sign/sign.component';
import { AdminlandComponent } from './pages/adminland/adminland.component';

import { environment } from '../environments/environment';

import { AngularFirestoreModule } from "@angular/fire/firestore";
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ContactComponent,
    AdventureComponent,
    SignComponent,
    AdminlandComponent,
    PageNotFoundComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MDBBootstrapModule.forRoot(),
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AngularFireModule.initializeApp(
      environment.firebaseConfig),
    AngularFireStorageModule,
    AngularFireDatabaseModule,
    AngularFirestoreModule

  ],
  providers: [FirebaseService],
  bootstrap: [AppComponent]
})
export class AppModule { }

/*
apiKey: "AIzaSyClubfVvIQOGB3ElakqIk0agKso5BNCH-A",
      authDomain: "grandtravel-60285.firebaseapp.com",
      projectId: "grandtravel-60285",
      storageBucket: "grandtravel-60285.appspot.com",
      messagingSenderId: "734129200683",
      appId: "1:734129200683:web:6bcced124d81c8978c146e"
      */
/*

<!-- The core Firebase JS SDK is always required and must be listed first -->
<script src="https://www.gstatic.com/firebasejs/8.2.10/firebase-app.js"></script>

<!-- TODO: Add SDKs for Firebase products that you want to use
     https://firebase.google.com/docs/web/setup#available-libraries -->

<script>
  // Your web app's Firebase configuration
  var firebaseConfig = {
    apiKey: "AIzaSyClubfVvIQOGB3ElakqIk0agKso5BNCH-A",
    authDomain: "grandtravel-60285.firebaseapp.com",
    projectId: "grandtravel-60285",
    storageBucket: "grandtravel-60285.appspot.com",
    messagingSenderId: "734129200683",
    appId: "1:734129200683:web:6bcced124d81c8978c146e"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
</script>
*/